import React from 'react'

const PartnerTrust = () => {
    return (
        <div className="_trust_logo_nft_wrapper">
            <div className="_trust_logo_nft_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12">
                            <div className="_trust_logo_nft_head">
                                <h4 className="_trust_logo_nft_head_txt">Connected and
                                    trusted by the encosystem to break boundaries
                                    by linking chains.</h4>
                                <img src="assets/img/trust-logo.svg" alt="icon" className="_trust_logo_nft_head_ic" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PartnerTrust